module.exports = __webpack_public_path__ + "img/money-bg.b9f59075.png";